import ReactMarkdown from 'react-markdown';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {oneLight} from 'react-syntax-highlighter/dist/cjs/styles/prism';


export function Home () {
    
    const markdownText = `
- **分组下拉框：**
    <select>
        <optgroup label="亚洲">
            <option value="China">中国</option>
            <option value="Japan">日本</option>
        </optgroup>
        <optgroup label="美洲">
            <option value="US">美国</option>
            <option value="Canada">加拿大</option>
        </optgroup>
    </select>
- **普通下拉：**
    <select>
        <option value="China">中国</option>
        <option value="Japan">日本</option>
        <optgroup label="美洲">
            <option value="US">美国</option>
            <option value="Canada">加拿大</option>
        </optgroup>
    </select>
    
    <input type="checkbox"/>
    <input type="radio"/>
    <input type="number">
    <input type="color">
    <input type="text">
    <input type="date">
    <input type="search">
    <span style="color: red" >你好</span>
`
    
    const textText = `
### 记录一些觉得有意思的写法、用法或者API，有空慢慢补充

*****


- 列表推导式：

    > 列表推导式：**用来创建新列表的简洁方式**，通常用于从现有的可迭代对象（如列表、元组、字符串等）中生成新的列表

    **用法：** \`[变量名 for 变量名 in 可迭代对象]\`
  
    * 常规用法：
        \`\`\`python
        data = [item for item in range(11)]
        print(data)    # 输出：[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        \`\`\`

    * 改变输出元素的值：

        \`\`\`python
        data = [item ** 2 for item in range(11)]
        print(data)    # 输出：[0, 1, 4, 9, 16, 25, 36, 49, 64, 81, 100]
        \`\`\`

    * 结合条件语句：
        
        \`\`\`python
        data = [item for item in range(11) if item % 2 == 0]
        print(data)    # 输出：[0, 2, 4, 6, 8, 10]
        \`\`\`

****

- 条件表达式：

    > 条件表达式：用于对一个值的选择性输出

    **用法：** \`Ture条件需要输出的值 if Ture条件 else False条件时输出的值\`

    * 常规用法：
        \`\`\`python
        value = {"name": '王英杰'}
        city = value.get('city') if value.get('city') else '深圳'
        print(city)    # 输出：深圳
  
        value = {"name": '王英杰', "city": '广州'}
        city = value.get('city') if value.get('city') else '深圳'
        print(city)    # 输出：广州
        \`\`\`
    
    * 利用索引从列表中取值：
        \`\`\`python
        value = {"name": '王英杰'}
        city = [value.get('city'), '深圳'][value.get('city') is None]
        print(city)  # 输出：深圳
    
        value = {"name": '王英杰', "city": '广州'}
        city = [value.get('city'), '深圳'][value.get('city') is None]
        print(city)  # 输出：广州
        \`\`\`
        在Python中， \`True\` 等于整数 \`1\` ，而 \`False\` 等于整数 \`0\`。
        所以当\`[value.get('city'), '深圳'][value.get('city') is None]\`中第二个列表中条件成立时，等同于：
        \`\`\`python
        value = {"name": '王英杰'}
        city = [value.get('city'), '深圳'][1] # 因为 value.get('city') is None 条件成立，返回True
        print(city)  # 输出：深圳
        \`\`\`
    
    * 快速取值：
        \`\`\`python
        value = {"name": '王英杰'}
        city = value.get('city') or '深圳'
        print(city)  # 输出：深圳
        \`\`\`
        当 \`value.get('city')\` 有值或者为True时，则赋予 \`value.get('city')\` 的值，反之则取 \`or\` 后面的默认值


****

- 匿名函数：
    > 快速简洁的创建一个函数，个人使用比较多的场景是作为回调函数使用
    其他场景使用比较少

    * 用法：
        
        \`\`\`python
        # 带参数
        sum = lambda x, y: x + y
        result = sum(10, 10)
        print(result)    # 输出：20
        
        # 不带参数
        func = lambda : 'Hello World'
        result = func()
        print(result)    # 输出：Hello World
        \`\`\`
    `
    
    
    return (
        <ReactMarkdown  children={textText} components={{
            code({ inline, className, children, ...data }) {
                const match = /language-(\w+)/.exec(className || '');
                return !inline && match ? (
                    <div>
                        <SyntaxHighlighter style={ oneLight } language={match[1]} PreTag="div" >
                            {String(children).replace(/\n$/, '')}
                        </SyntaxHighlighter>
                    </div>
                ) : <code>{children}</code>
            }
        }} />
    )
}
















